import styled from '@emotion/styled'
import { FontWeight, Text } from '@hhgtech/hhg-components/mantine'
import { rem } from '@mantine/core'

import { CardHealthTool } from '../CardHealthToolV2'

export const StyledHealthToolCard = styled(CardHealthTool)`
  height: 134px;
`
export const StyledOtherToolTitle = styled(Text)`
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  letter-spacing: -0.4px;
  font-weight: ${FontWeight.semiBold};
`

export const StyledOtherToolDesc = styled(Text)`
  font-size: ${rem(13)};
  line-height: ${rem(20)};
  letter-spacing: -0.3px;
`
